import store from '../store/';
import router from '../router/';

import toastr from 'toastr';
import moment from 'moment';
import { get, eachRight, replace } from 'lodash';

export default {
  store() {
    return store;
  },
  // to logout user
  logout() {
    return axios
      .post('/logout')
      .then(response => response.data)
      .then(response => {
        toastr.success(response.message);
      })
      .catch(error => {
        // this.showDataErrorMsg(error);
      });
  },

  // to get authenticated user data
  authUser() {
    return axios
      .get('/api/auth/user')
      .then(response => response.data)
      .then(response => {
        return response;
      })
      .catch(error => {
        this.showDataErrorMsg(error);
      });
  },

  // to check for authenticated user
  check() {
    return axios
      .post('/api/auth/check/')
      .then(response => response.data)
      .then(response => {
        console.log(response);
        store.dispatch('auth/setConfig', response.config);

        if (response.ip_restricted) localStorage.setItem('ip_restricted', true);
        else localStorage.removeItem('ip_restricted');

        if (response.authenticated) {
          store.dispatch('auth/setAuthUserDetail', {
            id: response.user.id,
            first_name: response.user.profile.first_name,
            last_name: response.user.profile.last_name,
            email: response.user.profile.email,
            avatar: response.user.profile.avatar,            
          });
          store.dispatch('auth/setPermission', response.permissions);
          store.dispatch('auth/setDefaultRole', response.default_role);

          this.setLastActivity();
        } else {
          store.dispatch('auth/resetAuthUserDetail');
        }

        return response.authenticated;
      })
      .catch(error => {
        console.log(error);
        store.dispatch('auth/resetAuthUserDetail');
        store.dispatch('auth/resetConfig');
      });
  },
  toastErrorAuth(){
    toastr.error('Пожалуйста авторизуйтесь или зарегистрируйтесь в системе', 'Ошибка системы');
  },

  // to set notification position
  notification() {
    var notificationPosition =
      this.getConfig('notification_position') || 'toast-top-right';
    toastr.options = {
      positionClass: notificationPosition
    };
    this.setLastActivity();

    $('[data-toastr]').on('click', function() {
      var type = $(this).data('toastr'),
        message = $(this).data('message'),
        title = $(this).data('title');
      toastr[type](message, title);
    });
  },

  setLastActivity() {
    if (!this.isScreenLocked()) store.dispatch('auth/setLastActivity');
  },

  // to check for last activity time and lock/unlock screen
  isScreenLocked() {
    let last_activity = this.getLastActivity();
    let lock_screen_timeout = this.getConfig('lock_screen_timeout');
    let last_activity_after_timeout = moment(last_activity)
      .add(lock_screen_timeout, 'minutes')
      .format('LLL');
    return moment().format('LLL') > last_activity_after_timeout;
  },

  // to append filter variables in the URL
  getFilterURL(data) {
    let url = '';
    $.each(data, function(key, value) {
      url += value ? '&' + key + '=' + encodeURI(value) : '';
    });
    return url;
  },

  getTwoFactorCode() {
    return store.getters['auth/getTwoFactorCode'];
  },

  getLastActivity() {
    return store.getters['auth/getLastActivity'];
  },

  // to get Auth Status
  isAuth() {
    return store.getters['auth/getAuthStatus'];
  },

  // to get Auth user detail
  getAuthUser(name) {
    if (name === 'full_name') {
      return (
        store.getters['auth/getAuthUser']('first_name') +
        ' ' +
        store.getters['auth/getAuthUser']('last_name')
      );
    } else if (name === 'avatar') {
      if (store.getters['auth/getAuthUser']('avatar')) {
        return '/' + store.getters['auth/getAuthUser']('avatar');
      }
      return '/images/avatar.png';
    }
    return store.getters['auth/getAuthUser'](name);
  },

  // to get User avatar
  getAvatar(user) {
    if (user && user.profile.avatar) return '/' + user.profile.avatar;
    else return '/images/avatar.png';
  },

  // to get config
  getConfig(config) {
    return store.getters['auth/getConfig'](config);
  },

  // to get default role name of system
  getDefaultRole(role) {
    return store.getters['auth/getDefaultRole'](role);
  },

  // to check role of authenticated user
  hasRole(role) {
    return store.getters['auth/hasRole'](this.getDefaultRole(role));
  },

  // to check permission for authenticated user
  hasPermission(permission) {
    return store.getters['auth/hasPermission'](permission);
  },

  // to check Admin role
  hasAdminRole() {
    if (this.hasRole('admin')) return 1;
    else return 0;
  },

  // to check whether a given user has given role
  userHasRole(user, role_name) {
    if (!user.roles) return false;

    let user_role = user.roles.filter(
      role => role.name === this.getDefaultRole(role_name)
    );
    if (user_role.length) return true;
    return false;
  },

  // to check feature is available or not
  featureAvailable(feature) {
    return this.getConfig(feature);
  },

  // returns not accessible message if permission is denied
  notAccessibleMsg() {
    toastr.error(this.trans('permission.permission_denied'));
  },

  // returns feature not available message if permission is denied
  featureNotAvailableMsg() {
    toastr.error(this.trans('general.feature_not_available'));
  },

  // returns user status
  getUserStatus(user) {
    let status = [];

    if (user.status === 'activated')
      status.push({
        color: 'success',
        label: this.trans('user.status_activated')
      });
    else if (user.status === 'pending_activation')
      status.push({
        color: 'warning',
        label: this.trans('user.status_pending_activation')
      });
    else if (user.status === 'pending_approval')
      status.push({
        color: 'warning',
        label: this.trans('user.status_pending_approval')
      });
    else if (user.status === 'banned')
      status.push({
        color: 'danger',
        label: this.trans('user.status_banned')
      });
    else if (user.status === 'disapproved')
      status.push({
        color: 'danger',
        label: this.trans('user.status_disapproved')
      });

    return status;
  },

  // to mass assign one object in another object
  formAssign(form, data) {
    for (let key of Object.keys(form)) {
      if (
        key !== 'originalData' &&
        key !== 'errors' &&
        key !== 'autoReset' &&
        key !== 'providers'
      ) {
        form[key] = data[key] || '';
      }
    }
    return form;
  },

  // to get date in desired format
  formatDate(date) {
    if (!date) return;

    return moment(date).format(this.getConfig('date_format'));
  },

  // to get date time in desired format
  formatDateTime(date) {
    if (!date) return;

    var date_format = this.getConfig('date_format');
    var time_format = this.getConfig('time_format');

    return moment(date).format(date_format + ' ' + time_format);
  },

  // to get time from now
  formatDateTimeFromNow(datetime) {
    if (!datetime) return;

    return moment(datetime).fromNow();
  },

  // to change first character of every word to upper case
  ucword(value) {
    if (!value) return;

    return value.toLowerCase().replace(/\b[a-z]/g, function(value) {
      return value.toUpperCase();
    });
  },

  // to change string into human readable format
  toWord(value) {
    if (!value) return;

    value = value.replace(/-/g, ' ');
    value = value.replace(/_/g, ' ');

    return value.toLowerCase().replace(/\b[a-z]/g, function(value) {
      return value.toUpperCase();
    });
  },

  // shows toastr notification for axios request
  showDataErrorMsg(error) {
    this.setLastActivity();

    if (error.error) {
      if (error.error.indexOf(' ') >= 0) toastr.error(error.error);
      else toastr.error(this.trans('general[error.error]'));

      if (error.error === 'token_expired') router.push('/login');
    } else if (error.response && error.response.status == 403) {
      toastr.error(this.trans('general.permission_denied'));
    } else if (
      error.response &&
      error.response.status == 422 &&
      error.response.data.error
    ) {
      toastr.error(error.response.data.error);
    } else if (error.response && error.response.status == 404) {
      toastr.error(this.trans('general.invalid_link'));
    } else if (
      error.response &&
      error.response.data.errors &&
      error.response.data.errors.message
    ) {
      toastr.error(error.response.data.errors.message[0]);
    } else {
      console.error(error);
      toastr.error('Произошла ошибка');
    }
  },

  // returns error message for axios request
  fetchDataErrorMsg(error) {
    return error.response.data.errors.message[0];
  },

  // shows toastr notification for axios form request
  showErrorMsg(error) {
    this.setLastActivity();

    if (error.error) {
      if (error.error.indexOf(' ') >= 0) toastr.error(error.error);
      else toastr.error(this.trans('general.' + error.error));

      if (error.error === 'token_expired') router.push('/login');
    } else if (error.response && error.response.status == 403) {
      toastr.error(this.trans('general.permission_denied'));
    } else if (
      error.response &&
      error.response.status == 422 &&
      error.response.data.error
    ) {
      toastr.error(error.response.data.error);
    } else if (
      error.response &&
      error.response.status == 422 &&
      error.response.data.errors
    ) {
      for (let e in error.response.data.errors) {
        toastr.error(error.response.data.errors[e]);
      }      
    }else if (error.response && error.response.status == 404) {
      toastr.error(this.trans('general.invalid_link'));
    } else if (error.errors && error.errors.message) {
      toastr.error(error.errors.message[0]);
    }
    else if (error.message) {
      toastr.error(error.message);
    }
    else {
      console.log(error);
    }
  },

  // returns error message for axios form request
  fetchErrorMsg(error) {
    return error.errors.message[0];
  },

  // round numbers as given precision
  roundNumber(number, precision) {
    precision = Math.abs(parseInt(precision)) || 0;
    var multiplier = Math.pow(10, precision);
    return Math.round(number * multiplier) / multiplier;
  },

  // round numbers as given precision
  formatNumber(number, decimal_place) {
    if (decimal_place === undefined) decimal_place = 2;
    return this.roundNumber(number, decimal_place);
  },

  // fill number with padding 
  formatWithPadding(n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
  },

  // generates random string of certain length
  randomString(length) {
    if (length === undefined) length = 40;
    var chars =
      '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var result = '';
    for (var i = length; i > 0; --i)
      result += chars[Math.floor(Math.random() * chars.length)];
    return result;
  },
  trans(string, args) {
    let value = get(window.i18n, string);
    console.log(value);
    eachRight(args, (paramVal, paramKey) => {
      value = replace(value, `:${paramKey}`, paramVal);
    });
    return value;
  },
  getImageUrl(image) {
    if (!image) {
      return '';
    }
    if (/https?:\/\//.test(image)) {
      return image;
    }
    if (image[0] != '/') {
      image = '/'+image;
    }
    let host = process.env.VUE_APP_API_URL;
    if (host[host.length-1] == '/' ) {
      host = host.slice(0, host.length-1);
    }
    return host + image;
  },
  filterTree(tree, roles) {
    return tree.reduce((acc, node) => {
      if (
        typeof node.roles === 'undefined' ||
        node.roles.findIndex(role => roles.indexOf(role) > -1) > -1
      ) {
        if (typeof node.children === 'undefined') {
          acc.push(node);
        } else {
          const children = this.filterTree(node.children);
          acc.push({ ...node, children });
        }
      }
      return acc;
    }, []);
  }
};
